export default "__VITE_ASSET__96d7b5e1__"